// @ts-nocheck
import{useEffect,useState}from"react"
import{Link}from"react-router-dom"
import{useAuth}from"@/components/layout/AuthProvider"
import{supabaseClient}from"@/lib/supabase/client"
import{FeedContainer}from"@/components/feed/FeedContainer"
import{motion}from"framer-motion"

export default function FeedPage(){
const{user,supabaseUser,initialized}=useAuth()
const[subscribedTopics,setSubscribedTopics]=useState<string[]>([])
const[hotTopics,setHotTopics]=useState<any[]>([])

useEffect(()=>{
if(!supabaseUser)return
supabaseClient.from("topic_subscriptions").select("topic_id").eq("user_id",supabaseUser.id)
.then(({data})=>setSubscribedTopics((data||[]).map((s:any)=>s.topic_id)))
},[supabaseUser?.id])

useEffect(()=>{
supabaseClient.from("topics").select("id,name,slug,post_count,subscriber_count")
.order("post_count",{ascending:false}).limit(7)
.then(({data})=>setHotTopics(data||[]))
},[])

return(
<div style={{maxWidth:1100,margin:"0 auto",padding:"1.5rem 1rem 5rem"}}>
  <div className="flex gap-5">
    <div style={{flex:1,minWidth:0}}>
      {!supabaseUser&&<GuestBanner/>}
      <FeedContainer userId={supabaseUser?.id||null} subscribedTopics={subscribedTopics}/>
    </div>
    <div className="hidden xl:block" style={{width:280,flexShrink:0}}>
      <div className="sq-panel p-4 mb-3">
        <div className="flex items-center gap-2 mb-3">
          <svg width={22} height={22} viewBox="0 0 48 48" fill="none"><rect width="48" height="48" rx="8" fill="#ff4500"/><path d="M15 17.5C15 14.462 17.462 12 20.5 12H29C30.105 12 31 12.895 31 14C31 15.105 30.105 16 29 16H20.5C19.672 16 19 16.672 19 17.5C19 18.328 19.672 19 20.5 19H27.5C30.538 19 33 21.462 33 24.5C33 27.538 30.538 30 27.5 30H19C17.895 30 17 30.895 17 32C17 33.105 17.895 34 19 34H28.5C29.328 34 30 34.672 30 35.5C30 36.328 29.328 37 28.5 37H19C16.239 37 14 34.761 14 32C14 29.239 16.239 27 19 27H27.5C28.328 27 29 26.328 29 25.5C29 24.672 28.328 24 27.5 24H20.5C17.462 24 15 21.538 15 18.5V17.5Z" fill="white"/></svg>
          <span className="sq-logo text-base">SQUIDS</span>
        </div>
        <p className="text-xs mb-4" style={{color:"var(--text2)",lineHeight:1.7}}>Africa's home for discussion, questions, and ideas. Where ideas surface.</p>
        <Link to="/post/create" className="sq-btn sq-btn-primary w-full justify-center py-2 text-xs mb-2 block text-center">Create Post</Link>
        {!supabaseUser&&<Link to="/auth/register" className="sq-btn sq-btn-outline w-full justify-center py-2 text-xs block text-center">Join SQUIDS</Link>}
      </div>
      {hotTopics.length>0&&(
        <div className="sq-panel p-4">
          <h3 className="font-outfit font-bold text-xs uppercase tracking-wider mb-3" style={{color:"var(--text3)"}}>Top Topics</h3>
          <div className="space-y-2">
            {hotTopics.map((t:any,i:number)=>(
              <Link key={t.id} to={`/topics/${t.slug}`} className="flex items-center gap-2 text-sm group">
                <span className="font-bold w-4 text-xs" style={{color:"var(--text3)"}}>{i+1}</span>
                <span className="font-semibold group-hover:text-brand transition-colors">t/{t.name}</span>
                <span className="ml-auto text-xs" style={{color:"var(--text3)"}}>{t.post_count||0}</span>
              </Link>
            ))}
          </div>
          <Link to="/topics" className="text-xs hover:underline mt-3 block" style={{color:"var(--brand)"}}>All topics →</Link>
        </div>
      )}
    </div>
  </div>
</div>
)
}

function GuestBanner(){
return(
<motion.div className="sq-panel p-4 mb-3 flex items-center justify-between gap-4 flex-wrap"
  initial={{opacity:0,y:-8}} animate={{opacity:1,y:0}}
  style={{borderColor:"rgba(255,69,0,.3)"}}>
  <div>
    <p className="font-outfit font-bold text-sm">Join SQUIDS</p>
    <p className="text-xs" style={{color:"var(--text2)"}}>Vote, comment, and be part of the community.</p>
  </div>
  <div className="flex gap-2 flex-shrink-0">
    <Link to="/auth/login" className="sq-btn sq-btn-outline text-xs px-3 py-1.5">Log In</Link>
    <Link to="/auth/register" className="sq-btn sq-btn-primary text-xs px-3 py-1.5">Sign Up</Link>
  </div>
</motion.div>
)
}
